



















































import { faSignInAlt, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope'
import { mapGetters } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { CCard },
  props: {
    urlId: {
      type: Number,
      default: 1,
      required: false
    },
    seller: {
      type: Object,
      required: true
    },
    withoutCard: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      sellerOnlyContactViaMessages: 'sellerOnlyContactViaMessages'
    }),
    ...mapDeps({ legacyUrlService: LegacyUrlService }),
    isDealerSite() {
      return this.$dep(DealerSiteService).routeIsOfDealerSite()
    },
    icons() {
      return {
        userPlus: faUserPlus,
        signIn: faSignInAlt,
        envelope: faEnvelope
      }
    },
    registerLink() {
      let link = this.legacyUrlService.getRegisterUrl()

      if (this.urlId) {
        link = this.legacyUrlService.getRegisterUrl({
          fromviewpromt: this.urlId
        })
      }

      if (this.isDealerSite && process.client) {
        link = `https://car.gr${link}`
      }

      return link
    },
    loginLink() {
      let link = '/login/'

      if (this.urlId) {
        link += '?fromviewpromt=' + this.urlId
      }

      return link
    }
  }
})
